module.exports = __webpack_public_path__ + "img/bicycle.3a12e88a.svg";